import { useEffect, useState } from "react";
import { MainBox } from "./components/mainPage/mainBox"
import { useMsal } from "@azure/msal-react";
import { useDispatch, useSelector } from "react-redux";
import { RequestProfileData } from "./common/authentication";
import { appInsights } from "./common/ApplicationInsights";
import { LoadPanel } from "devextreme-react";
import { Drawer } from "devextreme-react";
import Toolbar, { Item } from 'devextreme-react/toolbar';
import NavigationList from "./NavigationList";
import { LogoutButton } from "./components/Menu/LogoutButton";
import Error from "./components/error/error";
import { GlobalNotification } from "./GlobalNotification";
import useSignalR from "./components/mainGrid/Hooks/useSignalR";
import { GetSilentTokent } from "./components/authentication/AuthenticationHelpers";
import { v4 as uuidv4 } from 'uuid';
import './Website.css';
import './components/Menu/drawer.css';
const timeoutInMins = 15;

export function Website() {
    const dispatch = useDispatch();
    const { instance, accounts } = useMsal();
    const userDataLoading = useSelector(state => state.userInfo.loading);
    const error = useSelector(state => state.userInfo.error);
    const authenticatedUser = useSelector(state => state.userInfo.userAuthenticated);
    const hubUrl = process.env.REACT_APP_BASE_URL;
    const [opened, setOpened] = useState(false);
    
    useSignalR(hubUrl, authenticatedUser);

    if (!window.sessionStorage.getItem('session_id')) {
        const generated_id = uuidv4();
        window.sessionStorage.setItem('session_id', generated_id);
    }

    useEffect(() => {
        appInsights.trackPageView("MainGrid");
        RequestProfileData(instance, accounts, authenticatedUser, dispatch);
    }, [instance, accounts, authenticatedUser]);

    setTimeout(async () => {
        try {
            await GetSilentTokent();
        } catch (error) {
            console.error('Error getting silent token on idle:', error);
        }
    }, timeoutInMins * 60000);

    const onOutsideClick = () => {
        setOpened(false);
    }

    if (error === true) {
        return <Error />
    }

    if (userDataLoading) {
        return (
            <LoadPanel
                visible={userDataLoading}
                message="Loading User Information"
            />
        );
    }

    return (
        <div className="menu-wrapper-container">
            <Toolbar className={"main-toolbar"} >
                <Item location="before"
                    widget="dxButton"
                    options={{
                        icon: 'menu',
                        onClick: () => setOpened(!opened)
                    }} />
                <Item location="after">
                    <LogoutButton />
                </Item>
            </Toolbar>
            <Drawer
                opened={opened}
                openedStateMode={'shrink'}
                position={'left'}
                revealMode={'expand'}
                closeOnOutsideClick={onOutsideClick}
                render={() => <NavigationList origin={"main"} />}>
                <div id="content" className="main-content">
                    <GlobalNotification/>
                    <MainBox componentIndex={1} />
                </div>
            </Drawer>
        </div>
    );
}